import { apiFetch } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const permissions = createWorkspaceResourceApi('sharing-permissions')

export const sharingApi = {
  list: permissions.list,
  add: permissions.create,
  accept: (token, payload) => apiFetch(`sharing-permissions/accept/${token}`, { method: 'POST', body: payload }),
  searchUserByEmail: (email) => apiFetch('users', { params: { email } }),
}
